import { render } from "./BaseRequiredInput.vue?vue&type=template&id=7a51ca57"
import script from "./BaseRequiredInput.vue?vue&type=script&lang=js"
export * from "./BaseRequiredInput.vue?vue&type=script&lang=js"

import exportComponent from "/Users/maksimzugan/code/nacd-3-family/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__